import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthenticationService } from '../../services/authentication_service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  if (authService.getToken()) {
    return true;
  }
  return router.createUrlTree(['/login']);
};
